import { jsx as _jsx } from "react/jsx-runtime";
import { SurveyMonkey as UISurveyMonkey } from "@jti/loyalty";
export const SurveyMonkey = (props) => _jsx(UISurveyMonkey, { ...props });
